import React from "react";
import { useMemo } from "react";
import { useTypedSelector } from "../../../../../store/reducers/use-typed-selector";
import { TemplateClassNames } from "../../../../../types/template-layouts";
import { IHomepageMainNavItems, IPostRegisterHomeModule, NavMainItems, PageModule } from "../../../../../types/working-model";
import { PostRegisterSideBar, RenderLiveModules } from './main-preview';

interface IHomeProps {
	navItem: IHomepageMainNavItems | undefined;
	eventMainNavItems: IHomepageMainNavItems[];
}

export const sortPostRegisterHomeModules = (modules: PageModule[], post_register_home_modules: IPostRegisterHomeModule[]): PageModule[] => {
	if (!modules?.length || !post_register_home_modules?.length) return [];
	const sorted: PageModule[] = [];
	const modulesMap: { [key: number]: PageModule } = modules.reduce((accum, curr) => {
		if (!curr.id) return accum;
		return {
			...accum,
			[curr.id]: curr,
		};
	}, {});

	post_register_home_modules.forEach(module => {
		if (modulesMap[module.module_id]) {
			sorted.push({
				...modulesMap[module.module_id],
				is_on: module.is_on,
			});
		}
	});

	return sorted;
};

const Home = React.forwardRef<HTMLDivElement, IHomeProps>(({ navItem, eventMainNavItems }, ref) => {

	const { logo, modules, post_register_home_modules, _template } = useTypedSelector(state => ({
		logo: state.CreateEventReducer?.workingEvent?.homepage?.header?.logo,
		modules: state.CreateEventReducer.workingEvent?.homepage?.modules,
		post_register_home_modules: state.CreateEventReducer.workingEvent?.homepage?.post_register_home_modules,
		_template: state.CreateEventReducer.workingEvent?.template.name,
	}));

	const sortedModules = useMemo(() => {
		if (!modules?.length || !post_register_home_modules?.length) return [];
		return sortPostRegisterHomeModules(modules, post_register_home_modules);
	}, [modules, post_register_home_modules]);

	const template = _template ? TemplateClassNames[_template] : TemplateClassNames.Apollo;

	if (!navItem?.is_on) return null;
	return (
		<>
			<PostRegisterSideBar {...{ eventMainNavItems, template, logo }} activeMenuItem={NavMainItems.Home} />
			<div className="post-register-home-preview">
				<RenderLiveModules ref={ref} modules={sortedModules} template={template} />
			</div>
		</>
	);
});

Home.displayName = "Home";

export default Home;
